import React, { Component } from 'react';
import { getJson, Auth } from '../Services';


interface IIdleCheckerProps {
    userData: number;
}

interface IIdleCheckerState {
    userData: number;
}

export class IdleChecker extends React.Component<IIdleCheckerProps, IIdleCheckerState> {
    constructor(props: IIdleCheckerProps) {
        super(props);
        this.state ={userData : props.userData};
    }

    timeout: NodeJS.Timeout | null = null;
    retryTimeout: NodeJS.Timeout | null = null;

    componentDidMount() {
        this.resetTimeout();
        window.addEventListener('mousemove', this.resetTimeout);
        window.addEventListener('keypress', this.resetTimeout);
    }

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        window.removeEventListener('mousemove', this.resetTimeout);
        window.removeEventListener('keypress', this.resetTimeout);
    }

    resetTimeout = () => {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(this.logout, this.state.userData * 60 * 1000); 
    };

    logout = () => {
        Auth.logout();
    };

    render() {
        return null;
    }
}
